module.exports = __webpack_public_path__ + "static/apple-icon-180x180-d507c220a4bf31d5687be4cca809e427.png";